import { useState, useEffect } from 'react';
import styles from './EditarTest.module.css';
import {
  FaTrash,
  FaEdit,
  FaEye,
  FaSadCry,
  FaBrain,
  FaMagic,
  FaRocket,
  FaDog,
  FaCat,
  FaBook,
  FaMusic,
  FaPuzzlePiece,
  FaTimes,
} from 'react-icons/fa';
import swal from 'sweetalert2'; 
import {useAuth} from '../../Auth/AuthContext';

const EditarTest = ({ testId, onBack, onTestUpdated }) => {
  const [formData, setFormData] = useState({
    te_nombre: '',
    te_descripcion: '',
    te_icon: '',
    te_tiempo_estimado: '',
    te_instrucciones: ''
  });
  const [originalData, setOriginalData] = useState({});
  const {getToken} = useAuth(); 
  const token = getToken(); 
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  // Lista de iconos disponibles
  const iconOptions = [
    { value: 'FaRocket', label: 'Cohete', icon: <FaRocket /> },
    { value: 'FaBook', label: 'Libro', icon: <FaBook /> },
    { value: 'FaMusic', label: 'Música', icon: <FaMusic /> },
    { value: 'FaTrash', label: 'Basura', icon: <FaTrash /> },
    { value: 'FaEdit', label: 'Editar', icon: <FaEdit /> },
    { value: 'FaEye', label: 'Ojo', icon: <FaEye /> },
    { value: 'FaSadCry', label: 'Llorar', icon: <FaSadCry /> },
    { value: 'FaBrain', label: 'Cerebro', icon: <FaBrain /> },
    { value: 'FaMagic', label: 'Magia', icon: <FaMagic /> },
    { value: 'FaDog', label: 'Perro', icon: <FaDog /> },
    { value: 'FaCat', label: 'Gato', icon: <FaCat /> },
    { value: 'FaPuzzlePiece', label: 'Puzzle', icon: <FaPuzzlePiece /> },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Limpiar error del campo al escribir
    if (error[name]) {
      setError(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  useEffect(() => {
    if (testId) {
      fetchTestData();
    }
  }, [testId]);

  const fetchTestData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/test/view/edit/${testId}`, { 
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      const data = await response.json();
      const test = data[0];

      if(test) {
        const processedData = {
          te_nombre: (test.te_nombre || '').trim(),
          te_descripcion: (test.te_descripcion || '').trim(),
          te_icon: (test.te_icon || '').trim(),
          te_tiempo_estimado: test.te_tiempo_estimado?.toString() || '',
          te_instrucciones: (test.te_instrucciones || '').trim()
        };
        setFormData(processedData);
        setOriginalData(processedData);
      }
    } catch (error) {
      console.error('Error:', error);
      setError('Error de conexión al cargar el test');
    } finally {
      setLoading(false);
    }
  };
  
  //Campos actualizados
const getUpdatedFields = () => {
  const updates = {};
  
  for (const key in formData) {
    const currentValue = (formData[key] || '').trim();
    const originalValue = (originalData[key] || '').trim();
    
    if (currentValue !== originalValue) {
      if(key ==="te_tiempo_estimado" && currentValue === ""){
        updates[key] = null;
      }
      else {
        updates[key] = formData[key].trim();
      }
    }
  }
  
  return updates;
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.te_nombre.trim() || !formData.te_descripcion.trim()) {
      setError('El nombre y la descripción son obligatorios');
      return;
    }
    const updated = getUpdatedFields();
    if(Object.keys(updated).length === 0) {
      setError('No hiciste ningún cambio para actualizar.');
      return;
    }
    setSaving(true);
    try {
      setError('');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/test/actualizar/${testId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updated),
      });
      const data = await response.json();
      if (response.ok) {
        await swal.fire({
          title: '¡Éxito!',
          text: 'El test ha sido actualizada correctamente',
          icon: 'success',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#242b57', 
          customClass: { 
            popup: 'popupbonito', 
          }
        });
        onTestUpdated(); 
        onBack();

      } else {
        setError(data.error || 'Error al actualizar el test');
      }

    } catch (error) {
      console.error('Error:', error);
      setError('Error de conexión al actualizar el test');
      swal.fire({
        title: 'Error de conexión',
        icon: 'error',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#242b57', 
        customClass: { 
          popup: 'popupbonito', 
        },
        });
    } finally {
      setSaving(false);
    }
  };

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContent}>
                    <div className={styles.loadingSpinner}></div>
                    <p className={styles.loadingText}>Cargando datos...</p>
                </div>
            </div>
        );
    }

return (
  <div className={styles.modalOverlay}>
    <div className={styles.modalContainer}>

      <div className={styles.modalHeader}>
        <h2>Editar Test</h2>
        <button className={styles.modalCloseBtn} onClick={onBack}>
          <FaTimes />
        </button>
      </div>
      
      <div className={styles.modalContent}>
        <div className={styles.preguntaForm}>
          <form onSubmit={handleSubmit}>
            <div className={styles.preguntaFormGroupWide}>
              <label htmlFor="te_nombre">
                Nombre del Test
              </label>
              <input
                type="text"
                id="te_nombre"
                name="te_nombre"
                value={formData.te_nombre}
                onChange={handleInputChange}
                placeholder="Ej: Test de Inteligencias Múltiples"
                className={styles.inputForm}
                required
              />
            </div>

            <div className={styles.preguntaFormGroup}>
              <label htmlFor="te_descripcion">
                Descripción
              </label>
              <textarea
                id="te_descripcion"
                name="te_descripcion"
                value={formData.te_descripcion}
                onChange={handleInputChange}
                placeholder="Describe el propósito y beneficios del test..."
                rows="4"
                className={styles.inputTarea}
                required
              />
            </div>

            <div className={styles.preguntaFormGroup}>
              <label htmlFor="te_icon">
                Icono del Test
              </label>
              <select
                id="te_icon"
                name="te_icon"
                value={formData.te_icon}
                onChange={handleChange}
                className={styles.inputForm}
              >
                {iconOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>

              <div className={styles.iconPreviewEditar}>
                <span className={styles.textAyuda}>Vista previa del icono</span>
                {iconOptions.find(opt => opt.value === formData.te_icon.trim())?.icon}
              </div>
            </div>

            <div className={styles.preguntaFormGroup}>
              <label htmlFor="te_tiempo_estimado">
                Tiempo estimado (minutos)
              </label>
              <input
                type="number"
                id="te_tiempo_estimado"
                name="te_tiempo_estimado"
                value={formData.te_tiempo_estimado}
                onChange={handleInputChange}
                placeholder="Ej. 15"
                min="1"
                max="120"
                className={styles.inputForm}
              />
            </div>

            <div className={styles.preguntaFormGroup}>
              <label htmlFor="te_instrucciones">
                Instrucciones
              </label>
              <textarea
                id="te_instrucciones"
                name="te_instrucciones"
                value={formData.te_instrucciones}
                onChange={handleInputChange}
                placeholder="Instrucciones detalladas para realizar el test..."
                rows="6"
                className={styles.inputTarea}
              />
            </div>

            <div>
              <button type="submit" className={styles.btnSave} disabled={saving}>
                {saving ? (
                  <>
                    <div className={styles.btnSpinner}></div>
                    Guardando...
                  </>
                ) : (
                  <>
                    Editar Test
                  </>
                )}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
);
};

export default EditarTest;